var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-article-true-cost-table',{attrs:{"title":_vm.$t('global.models.article-true-cost.heading'),"subtitle":_vm.$t('global.models.article-true-cost.subheading'),"formConfigName":'default-with-article'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }